import React, { useEffect, useState } from "react";
import "./SlimEvent.css";

const SlimEvent = () => {
    const formStartTime = new Date("2026-05-06T15:00:00"); // 6 May, 3 PM
    const endTime = new Date(formStartTime.getTime() + 24 * 60 * 60 * 1000);

    const [timeLeft, setTimeLeft] = useState("");
    const [isFormActive, setIsFormActive] = useState(true);

    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date();

            if (now < formStartTime) {
                // BEFORE START
                const diff = formStartTime - now;

                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff / (1000 * 60)) % 60);
                const seconds = Math.floor((diff / 1000) % 60);

                setTimeLeft(`Starts in ${hours}h ${minutes}m ${seconds}s`);
                setIsFormActive(false);

            } else if (now >= formStartTime && now <= endTime) {
                // ACTIVE WINDOW
                const diff = endTime - now;

                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff / (1000 * 60)) % 60);
                const seconds = Math.floor((diff / 1000) % 60);

                setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
                setIsFormActive(true);

            } else {
                // EXPIRED
                setIsFormActive(false);
                setTimeLeft("Expired");
                clearInterval(timer);
            }

        }, 1000);

        return () => clearInterval(timer);
    }, [formStartTime, endTime]);

    return (
        <section className="slim-event">
            <div className="slim-content container-fluid">
                <div className="row align-items-center text-center text-lg-start">

                    {/* LEFT */}
                    <div className="col-lg-6 px-5">
                        <div className="slim-text">

                            <h5 className="slim-sub">Johar!</h5>

                            <h1 className="slim-title">
                                State Level <span>Influencer Meet 2026</span>
                            </h1>

                            <p className="slim-desc">
                                Jharkhand Tourism is bringing together voices that don’t just create, but shape how stories are seen and felt.
                            </p>

                            <p className="slim-desc">
                                SLIM 2026 is where perspectives meet purpose, and creators become storytellers of a land waiting to be rediscovered.
                            </p>

                            <p className="slim-highlight">
                                Set against the scenic charm of <b>Patratu</b>, this isn’t just an event — it’s the beginning of fresh narratives.
                            </p>

                            <div className="slim-tags">
                                <span>#SLIM2026</span>
                                <span>#JharkhandTourism</span>
                                <span>#IncredibleIndia</span>
                                <span>#DigitalCreators</span>
                            </div>

                            {/* CTA + TIMER */}
                            {/* <div className="slim-cta">

                                {timeLeft.startsWith("Starts in") ? (
                                    <>
                                        <button className="register-btn upcoming disabled" disabled>
                                            Registration Opens Soon
                                        </button>

                                        <div className="timer-box">
                                            {timeLeft}
                                        </div>
                                    </>
                                ) : isFormActive ? (
                                    <>
                                        <a
                                            href="https://forms.gle/cB9cZZNjVo3D8TS1A"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="register-btn"
                                        >
                                            Register Now
                                        </a>

                                        <div className="timer-box">
                                            Closes in: <span>{timeLeft}</span>
                                        </div>
                                    </>
                                ) : (
                                    <button className="register-btn disabled" disabled>
                                        Registration Closed
                                    </button>
                                )}

                            </div> */}

                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="col-lg-6 px-5">
                        <div className="slim-image-wrap">
                            <img
                                src="/assets/Events/slim-secondary.jpeg"
                                alt="SLIM Event"
                                className="slim-main-img"
                            />

                            <div className="slim-date-box">
                                <span>📅 11 May 2026</span>
                                <span>📍 Patratu</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default SlimEvent;